import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const InteractLogs = () => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  const pluginCode = 'INTERACT_LOG_VIEWER_PLUGIN';
  const entity = 'INTERACT';

  useEffect(() => {
    rsrc.viewerFieldDefs(module, pluginCode, {}, entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [module]);

  const onGridReady = () => {
    const dataSource = {
      getRows: (params) => {
        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);

        const reqParam = {
          startRow: params.startRow,
          endRow: params.endRow,
          expr,
        };

        buildAndSetExportReq(reqParam);

        rsrc.viewerRows(module, pluginCode, reqParam, entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        });

        rsrc.viewerCount(module, pluginCode, reqParam, entity).then(count => {
          gridRef.current.setCount(count);
        });
      }
    };

    gridRef.current.setDataSource(dataSource);
  };

  const buildAndSetExportReq = (reqParam) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      name: 'Interact Logs Export',
      module,
      entity,
      uiType: 'VIEWER',
      viewerPluginCode: pluginCode,
      viewerReqParam: reqParam,
      fieldDefs,
    };

    setExportReq(exportReq);
  };

  return (
    fieldDefs &&
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Title icon={far.faListUl} title="Interact Logs" />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <ExportButton exportReq={exportReq} />
        </Box>
      </Box>
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}
      />
    </>
  );
};
